import { AnnouncementTranslationDto } from 'api/announcements/models/AnnouncementDto';

const FALLBACK_ISO = 'fr';

/**
 * Picks the announcement title/message for the viewer's language (iso), falling back to the
 * platform default language and then to any filled translation.
 */
export function resolveTranslation(
    translations: AnnouncementTranslationDto[] | undefined,
    iso: string | null | undefined
): { title: string; message: string } {
    if (!translations || !translations.length) {
        return { title: '', message: '' };
    }

    const filled = (t?: AnnouncementTranslationDto) => !!t && (!!t.title || !!t.message);
    const byIso = (target?: string | null) =>
        translations.find(t => (t.iso || '').toLowerCase() === (target || '').toLowerCase() && filled(t));

    const found = byIso(iso) || byIso(FALLBACK_ISO) || translations.find(filled) || translations[0];

    return { title: found.title || '', message: found.message || '' };
}
